/*

  ref:
  https://codepen.io/Karl53/pen/MbYrPN

*/
import { Line } from 'vue-chartjs'
import appConfig from '@/config-app.js'

export default {
  extends: Line,
  props: ['valuesData'],
  data () {
    return {
      'options': {
        'responsive': true,
        'maintainAspectRatio': false,
        'legend': {
          'display': false // Oculta el Label del Dataset
        },
        'tooltips': appConfig.dashboardConfig.tooltips,
        'hover': {
          // Overrides the global setting
          'mode': 'index'
        },
        'animation': {
          // 'animateScale': true,
          'animateRotate': true,
          'onComplete': function () {
          }
        },
        'scales': {
          'yAxes': [
            {
              'type': 'linear',
              // 'display': true,
              'stacked': false,
              'position': 'left',
              'ticks': {
                'display': true,
                'min': 0,
                // 'max': 100,
                'fontColor': '#232323',
                'fontSize': 14
              },
              'gridLines': {
                'tickMarkLength': 40 // Padding entre lineas y ticks
              }
            }
          ],
          'xAxes': [{
            // 'display': true,
            'stacked': true,
            'barThickness': 40, // Grosor barra
            'ticks': {
              'display': true,
              'fontColor': '#232323',
              'fontSize': 12,
              'padding': 20
            },
            'gridLines': {
              'display': true, // lineas
              'drawBorder': false, // línea inicial
              'zeroLineWidth': 2, // Grosor línea inicial
              'zeroLineColor': '#ff0000', // Color línea inical
              'lineWidth': 2, // Grosor líneas
              'color': '#b3c7af', // Color Líneas
              'drawTicks': false // centra la barra
            }
          }]
        }
      }
    }
  },
  mounted () {
    // console.log('--', this.datasets)
    this.renderChart(this.datasets, this.options)
  },
  computed: {
    datasets () {
      return {
        'labels': this.valuesData.labels,
        'datasets': [
          {
            'type': 'line',
            'lineTension': 0,
            'pointStyle': 'rect', // tipo rectangulo de punto
            'pointRadius': 5,
            // 'pointHoverRadius': 10,
            // 'pointHitRadius': 10,
            'borderColor': this.valuesData.lineOne.color,
            'pointBackgroundColor': this.valuesData.lineOne.color,
            'borderWidth': 2,
            'fill': false,
            'data': this.valuesData.lineOne.data
          },
          {
            'type': 'line',
            'lineTension': 0,
            'pointStyle': 'rect', // tipo rectangulo de punto
            'pointRadius': 5,
            // 'pointHoverRadius': 10,
            'borderColor': this.valuesData.lineTwo.color,
            'pointBackgroundColor': this.valuesData.lineTwo.color,
            'borderWidth': 2,
            'fill': false,
            'data': this.valuesData.lineTwo.data
          }
        ]
      }
    }
  },
  methods: {
    getDiffPorcent () {
      return 100 - this.valuesData.value
    }
  },
  watch: {
    valuesData () {
      // console.log(`change---> ${this.valuesData.dataOne[0]} , ${this.datasets.datasets[0].data[0]}`)
      this._data._chart.destroy()
      this.renderChart(this.datasets, this.options)
    }
  }
}
